import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import {DemoAddComponent} from '../demo/demo-add/demo-add.component';
import {ProfileAuditComponent} from '../profile/profile-audit/profile-audit.component';
import {PostAuditComponent} from '../profile/post/post-audit/post-audit.component';
import {ShortcutNumbersPipe} from '../helper/shortcut-numbers.pipe';
import {SeparateNumbersPipe} from '../helper/separate-numbers.pipe';
import {ProgressComponent} from '../profile/progress/progress.component';
import {CommentTimeComponent} from '../profile/charts/comment-time/comment-time.component';
import {EngagementRateComponent} from '../profile/charts/engagement-rate/engagement-rate.component';
import {InteractionAnalyzeComponent} from '../profile/charts/interaction-analyze/interaction-analyze.component';
import {FollowersEngageComponent} from '../profile/charts/followers-engage/followers-engage.component';
import {FollowersLocationComponent} from '../profile/charts/followers-location/followers-location.component';
import {FollowersReliabilityComponent} from '../profile/charts/followers-reliability/followers-reliability.component';
import {FollowersDemographyComponent} from '../profile/charts/followers-demography/followers-demography.component';
import {ProfileAnalyzeComponent} from '../profile/charts/profile-analyze/profile-analyze.component';
import {ChartService} from '../profile/chart.service';
import {ChartModule} from 'angular-highcharts';
// import {RoundProgressModule} from 'angular-svg-round-progressbar';
import {ProfileMediaComponent} from '../profile/profile-media/profile-media.component';
import {ProfileListComponent} from '../profile/profile-list/profile-list.component';
import {DemoListComponent} from '../demo/demo-list/demo-list.component';
// import {CountriesMapModule} from 'countries-map';
import {ExportXlsComponent} from '../profile/export/export-xls/export-xls.component';
import {AuditPlaceholderComponent} from '../profile/audit-placeholder/audit-placeholder.component';
import {AuditExampleComponent} from '../profile/audit-example/audit-example.component';
import {HelperService} from './helper.service';
import { CopyHrefComponent } from './copy-href/copy-href.component';
import { ClipboardModule } from 'ngx-clipboard';
import {ProfileAutocompleteComponent} from '../profile/profile-autocomplete/profile-autocomplete.component';
import {ProfileFormComponent} from '../profile/profile-form/profile-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PieLegendComponent} from '../profile/charts/pie-legend/pie-legend.component';
import { ExtraZeroPipe } from './extra-zero.pipe';
import {AuditNoMentionComponent} from '../profile/audit-no-mention/audit-no-mention.component';
import {UserEditPasswordComponent} from '../user/user-edit-password/user-edit-password.component';
import {UserRankComponent} from '../profile/rank/user-rank/user-rank.component';
import { PreloadImageDirective } from './preload-image.directive';
import { PromoBannerComponent } from './promo-banner/promo-banner.component';
import {CountdownComponent} from '../special-offer/countdown/countdown.component';
import {PromoBannerService} from './promo-banner.service';
import {PriceBoxComponent} from '../payment/pricing/price-box/price-box.component';
import {PricePopupComponent} from '../payment/pricing/price-popup/price-popup.component';
import {ProfileAuditProComponent} from '../profile/profile-audit-pro/profile-audit-pro.component';
import {BreadcrumbsComponent} from './breadcrumbs/breadcrumbs.component';
import {LoaderComponent} from './loader/loader.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ChartModule,
    // RoundProgressModule,
    // CountriesMapModule,
    ClipboardModule,
    ReactiveFormsModule,
    FormsModule,
    BreadcrumbsComponent
  ],
  declarations: [
    DemoAddComponent,
    ProfileAuditComponent,
    ProfileAuditProComponent,
    PostAuditComponent,
    ShortcutNumbersPipe,
    SeparateNumbersPipe,
    ProgressComponent,
    FollowersReliabilityComponent,
    InteractionAnalyzeComponent,
    FollowersDemographyComponent,
    CommentTimeComponent,
    FollowersLocationComponent,
    ProfileAnalyzeComponent,
    FollowersEngageComponent,
    EngagementRateComponent,
    ProfileMediaComponent,
    ProfileListComponent,
    DemoListComponent,
    ExportXlsComponent,
    AuditPlaceholderComponent,
    AuditExampleComponent,
    CopyHrefComponent,
    ProfileAutocompleteComponent,
    ProfileFormComponent,
    PieLegendComponent,
    ExtraZeroPipe,
    AuditNoMentionComponent,
    UserEditPasswordComponent,
    UserRankComponent,
    PreloadImageDirective,
    PromoBannerComponent,
    CountdownComponent,
    PriceBoxComponent,
    PricePopupComponent,
    LoaderComponent
  ],
  providers: [
    ChartService,
    HelperService,
    PromoBannerService
  ],
  exports: [
    ProfileAuditComponent,
    ProfileAuditProComponent,
    PostAuditComponent,
    ExportXlsComponent,
    ShortcutNumbersPipe,
    AuditPlaceholderComponent,
    CopyHrefComponent,
    ProfileAutocompleteComponent,
    ProfileFormComponent,
    PieLegendComponent,
    ExtraZeroPipe,
    AuditNoMentionComponent,
    InteractionAnalyzeComponent,
    AuditExampleComponent,
    UserEditPasswordComponent,
    UserRankComponent,
    PreloadImageDirective,
    PromoBannerComponent,
    CountdownComponent,
    PriceBoxComponent,
    PricePopupComponent,
    LoaderComponent
  ]
})
export class ShareModule { }
